import { aiProviderIdSchema } from './runtime.js';
import { aiProviderStatusIdSchema } from './role-config.js';
/** Exhaustive admin credential provider ids (zod SSOT). */
export const AI_PROVIDER_STATUS_IDS = aiProviderStatusIdSchema.options;
/** Exhaustive runtime text-gateway provider ids (zod SSOT). */
export const AI_RUNTIME_PROVIDER_IDS = aiProviderIdSchema.options;
/** Text LLM credential providers (excludes STT-only speechkit). */
export const AI_TEXT_CREDENTIAL_PROVIDER_IDS = AI_PROVIDER_STATUS_IDS.filter((id) => id !== 'speechkit');
/** Direct HTTP API providers for platform model ids (excludes remote_runner). */
export const AI_DIRECT_API_PROVIDER_IDS = AI_RUNTIME_PROVIDER_IDS.filter((id) => id !== 'remote_runner');
export function parseAiProviderStatusId(value) {
    const trimmed = value.trim();
    return AI_PROVIDER_STATUS_IDS.includes(trimmed)
        ? trimmed
        : null;
}
export function parseAiProviderId(value) {
    const trimmed = value.trim();
    return AI_RUNTIME_PROVIDER_IDS.includes(trimmed) ? trimmed : null;
}
export function parseDirectApiProviderId(value) {
    const parsed = parseAiProviderId(value);
    if (!parsed || parsed === 'remote_runner')
        return null;
    return parsed;
}
export function isDirectApiProviderId(provider) {
    return provider !== 'remote_runner';
}
/** Maps stored provider id to Platform Kit wire provider (OpenAI-compatible → openai). */
export function toRuntimeWireProvider(provider) {
    return provider === 'openai_compatible' ? 'openai' : provider;
}
//# sourceMappingURL=provider-catalog.js.map